export type BugReport = {
  id: string;
  mode: string | null;
  description: string;
  status: string;
  priority: string;
  created_at: string;
  version: string | null;
  resolved_at?: string | null;
  resolution_summary?: string | null;
  route_path?: string | null;
  view_context?: string | null;
};

export async function bugReportApiFetch<T>(
  path: string,
  method: "GET" | "POST",
  token: string,
  body?: unknown,
): Promise<{ ok: true; data: T } | { ok: false; error: string }> {
  try {
    const res = await fetch(path, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: body != null ? JSON.stringify(body) : undefined,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.ok === false) return { ok: false, error: json.error || `HTTP ${res.status}` };
    return { ok: true, data: json as T };
  } catch (e: unknown) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}
